// extracted by mini-css-extract-plugin
export default {"ColorThumbnail":"ColorThumbnail_ColorThumbnail__lF1Rx","active":"ColorThumbnail_active__f76Ny"};